import React from "react";
import EnrollmentForm from "../../../documents/components/enrollmentApplications/components/enrollmentForm/EnrollmentForm";
import styles from "./AplikacijeZaUpis.module.css";

function AplikacijeZaUpis({ evidentionUserID }) {
  return (
    <div className={styles.wrapper}>
      <div>
        <div>
          <h1 className={styles.header}>Aplikacije za upis</h1>
        </div>
        <EnrollmentForm evidentionUserID={evidentionUserID} />
      </div>
    </div>
  );
}

export default AplikacijeZaUpis;
